import { render, staticRenderFns } from "./TrialCategory.vue?vue&type=template&id=0fe1b408&scoped=true"
import script from "./TrialCategory.vue?vue&type=script&lang=js"
export * from "./TrialCategory.vue?vue&type=script&lang=js"
import style0 from "./TrialCategory.vue?vue&type=style&index=0&id=0fe1b408&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe1b408",
  null
  
)

export default component.exports